module.exports = require("@pb/kit-util-is-element-in-view-port");